import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SlimScrollModule } from 'ng2-slimscroll';
import { PrimecalendarRoutingModule } from './primecalendar-routing.module';
import { PrimeCalendarComponent } from './prime-calendar/prime-calendar.component';
import { BookingEntryComponent } from './booking-entry/booking-entry.component';
import { GuestBookingComponent } from './guest-booking/guest-booking.component';
import { ViewSummaryComponent } from './view-summary/view-summary.component';
import { WalkinBookingComponent } from './walkin-booking/walkin-booking.component';
import { UnblockBlockDateComponent } from './unblock-date/unblock-date.component';
import { BlockDateComponent } from './block-dates/block-dates.component';
import { SharedModule } from './../shared/shared.module';
import { BookingLogPopup } from './booking-log-popup/booking-log-popup.component';
import { BlockedslotsUnitPipe } from './blockedslots-unit.pipe';
import { ViewInvoice } from './view-invoice/view-invoice.component';
@NgModule({
  imports: [
    CommonModule,
    PrimecalendarRoutingModule,
    SharedModule,
    SlimScrollModule
  ],
  declarations: [PrimeCalendarComponent, BookingEntryComponent, GuestBookingComponent, ViewSummaryComponent, BlockDateComponent, UnblockBlockDateComponent, WalkinBookingComponent, BookingLogPopup, BlockedslotsUnitPipe, ViewInvoice]
})
export class PrimecalendarModule { }



// WEBPACK FOOTER //
// ./src/app/primecalendar/primecalendar.module.ts